import { AbstractControl, FormGroup, FormControl } from '@angular/forms';
export class BaseFormValidation {

    protected isFormValid(form: FormGroup): boolean {
        if (form.dirty && form.invalid) {
            return false;
        } else {
            let controlKeys = Object.keys(form.controls),
                result = true;
            controlKeys.forEach(k => {
                let control = form.get(k);
                if (control.dirty && control.invalid)
                    result = false;
                return;
            });
            return result;
        }
    }


    protected formValidationMsg(form: FormGroup) {
        if (!this.isFormValid(form)) {
            let controlKeys = Object.keys(form.controls),
                result = '';
            controlKeys.forEach(k => {
                let control = form.get(k);
                if (!control.errors)
                    return;
                if (control.errors.minLength) {
                    result = control.errors.minLength;
                    return;
                } else if (control.errors.passwordStrength) {
                    result = control.errors.passwordStrength;
                    return;
                } else if (control.errors.pattern) {
                    result = `${k} is in wrong format`;
                    return;
                } else if (control.errors.matchPassword) {
                    result = control.errors.matchPassword
                    return;
                }
            });
            return result;
        }
    }

    protected getError(control: FormControl): string {
        if (!control.errors)
            return;
        else if (control.errors.matDatepickerParse) {
            return `Use 'mm/dd/yyyy format'`;
        }
        else if(control.errors.invalid){
            return 'Value is invalid.'
        }
        else if (control.errors.required) {
            return 'Required';
        }
        else if(control.errors.invalidEmail) {
            return 'Please enter a valid Email Address';
        }
        else if(control.errors.pattern){
            return 'Value does not match pattern'
        }
        else if (control.errors.min) {
            return `Min: ${control.errors.min.min}`;
        }
        else if (control.errors.max) {
            return `Max: ${control.errors.max}`;
        }
        else if (control.errors.maxlength) {
            return `Max: ${control.errors.maxlength.requiredLength}`;
        }
        else if (control.errors.minLength) {
            return `Min: ${control.errors.minLength}`;
        }
        else if (control.errors.wrongReferral) {
            return `Wrong referral code`;
        }
        else if (control.errors.lettersOnly) {
            return control.errors.lettersOnly;
        }
        // else if(control.errors.noWhitespaceEmail){
        //     return control.errors.noWhitespaceEmail;
        // }
        else if (control.errors.numericRequired) {
            return control.errors.numericRequired;
        }
        else if(control.errors.accountMismatch){
            return 'The entered account numbers do not match.';
        }
        else if(control.errors.routingMismatch){
            return 'The entered routing numbers do not match.';
        }
        else if(control.errors.isAgeInRange){
            return 'Date of Birth is out of eligibility range.'
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/validators/base-form-validation.ts